import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncateFilter {
  transform(value: string, limit: number, needle: string, trail: string) : string {

    limit = limit > 0 ? limit : 10;
	trail = trail ? trail : '...'; 
	let sub = needle ? value.indexOf(needle) : limit;

    return value.length > limit ? value.substring(0, sub) + trail : value;
  }
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/pipes/truncate.pipe.ts